import { render, staticRenderFns } from "./BulletinListPage.vue?vue&type=template&id=63a93f90&scoped=true"
import script from "./BulletinListPage.vue?vue&type=script&lang=js"
export * from "./BulletinListPage.vue?vue&type=script&lang=js"
import style0 from "./BulletinListPage.vue?vue&type=style&index=0&id=63a93f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a93f90",
  null
  
)

export default component.exports